export default {"src":"/_next/static/media/ic_verified_badge.3d76ffe5.svg","height":14,"width":14};